module.exports = __webpack_public_path__ + "img/end-call.537ad515.svg";